


type UnitCategory = 
    'Volume'
    | 'Pressure'
    | 'Flow Rate'
    | 'Temperature'
    | 'Humidity'
    | 'Water Treatment / Environmental Monitoring'
    | 'Water Quality'
    | 'Air Quality'
    | 'Tank Monitoring'
    | 'Turbine Speed'
    | 'Wind Speed'
    | 'Miscellaneous';


interface UnitEntry {
    value: string
    category: UnitCategory
    name: string
}

interface Units {
    [unitCode: string]: UnitEntry;
}

export const inputUnits: Units = {
    "01": {
        value: "l",
        name: "Litres",
        category: 'Volume'
    },
    "02": {
        value: "m3",
        name: "m³",
        category: "Volume"
    },
    "03": {
        value: "bar",
        name: "Bar",
        category: 'Pressure'
    },
    "04": {
        value: "mbar",
        name: "mbar",
        category: 'Pressure'
    },
    "05": {
        value: "mH2O",
        name: "mH₂O",
        category: 'Pressure'
    },
    "06": {
        value: "psi",
        name: "PSI",
        category: 'Pressure'
    },
    "07": {
        value: "gallons",
        name: "US Gallons",
        category: 'Volume'
    },
    "08": {
        value: "ft3",
        name: "ft³",
        category: 'Volume'
    },
    "09": {
        value: "l/s",
        name: "l/s",
        category: 'Flow Rate'
    },
    "10": {
        value: "m3/h",
        name: "m³/h",
        category: 'Flow Rate'
    },
    "11": {
        value: "Ml/d",
        name: "Ml/d",
        category: 'Flow Rate'
    },
    "12": {
        value: "kPa",
        name: "kPa",
        category: 'Pressure'
    },
    "13": {
        value: "ftH2O",
        name: "ftH₂O",
        category: 'Pressure'
    },
    "14": {
        value: "kg/cm2",
        name: "kg/cm²",
        category: 'Pressure'
    },
    //"15": {
    //    value: "mm",
    //    name: "mm",
    //    category: "Level / Depth"
    //},
    //"16": {
    //    value: "cm",
    //    name: "cm",
    //    category: "Level / Depth"
    //},
    "17": {
        value: "C",
        name: "°C",
        category: 'Temperature'
    },
    "18": {
        value: "F",
        name: "°F",
        category: "Temperature"
    },
    "19": {
        value: "%RH",
        name: "%RH",
        category: "Humidity"
    },
    "20": {
        value: "pH",
        name: "pH",
        category: "Water Treatment / Environmental Monitoring"
    },
    "21": {
        value: "μS/cm",
        name: "μS/cm",
        category: "Water Quality"
    },
    "22": {
        value: "mS/cm",
        name: "mS/cm",
        category: "Water Quality"
    },
    "23": {
        value: "S/cm",
        name: "S/cm",
        category: "Water Quality"
    },
    "24": {
        value: "TDS ppm",
        name: "TDS ppm",
        category: "Water Quality"
    },
    "25": {
        value: "TDS mg/L",
        name: "TDS mg/L",
        category: "Water Quality"
    },
    "26": {
        value: "NTU",
        name: "NTU",
        category: "Water Quality"
    },
    "27": {
        value: "FTU",
        name: "FTU",
        category: "Water Quality"
    },
    "28": {
        value: "mg/l",
        name: "mg/l",
        category: "Water Quality"
    },
    "29": {
        value: "ppm solids",
        name: "ppm solids",
        category: "Water Quality"
    },
    "30": {
        value: "ppm",
        name: "ppm",
        category: "Water Quality"
    },
    "31": {
        value: "% saturation",
        name: "% saturation",
        category: "Water Quality"
    },
    "32": {
        value: "ppb",
        name: "ppb",
        category: "Water Quality"
    },
    "33": {
        value: "% vol",
        name: "% vol",
        category: "Air Quality"
    },
    "34": {
        value: "% full",
        name: "% full",
        category: "Tank Monitoring"
    },
    "35": {
        value: "RPM",
        name: "RPM",
        category: "Turbine Speed"
    },
    "36": {
        value: "m/s",
        name: "m/s",
        category: "Wind Speed"
    },
    "37": {
        value: "%",
        name: "%",
        category: "Miscellaneous"
    }
}